const VALID_PATH = /^\/teacher-invitations\/[A-Za-z0-9-]{8,100}$/;

export function teacherInvitationPath(value: unknown): string | null {
  return typeof value === "string" && VALID_PATH.test(value) ? value : null;
}
